const FC_Error = Error

export const IMPERATIVE = 'IMPERATIVE'
export const FUNCTION = 'FUNCTION'
export const HIDE = 'HIDE'
export const FORMAT_AS_FLOAT = 'FORMAT_AS_FLOAT'
export const FORMAT_AS_RATIO = 'FORMAT_AS_RATIO'

export const IDENTIFIER = 'IDENTIFIER'
export const STRING = 'STRING'
export const NUMBER = 'NUMBER'

export const RIGHT_ARROW = 'RIGHT_ARROW'
export const LEFT_ARROW = 'LEFT_ARROW'
export const RIGHT_PIPE = 'RIGHT_PIPE'
export const LEFT_PIPE = 'LEFT_PIPE'
export const LEFT_PAREN = 'LEFT_PAREN'
export const RIGHT_PAREN = 'RIGHT_PAREN'
export const LEFT_BRACE = 'LEFT_BRACE'
export const RIGHT_BRACE = 'RIGHT_BRACE'
export const LEFT_BRACKET = 'LEFT_BRACKET'
export const RIGHT_BRACKET = 'RIGHT_BRACKET'
export const DOT = 'DOT'
export const COMMA = 'COMMA'
export const COLON = 'COLON'
export const PLUS = 'PLUS'
export const MINUS = 'MINUS'
export const TIMES = 'TIMES'
export const SLASH = 'SLASH'
export const PERCENT = 'PERCENT'
export const HAT = 'HAT'
export const DOLLAR = 'DOLLAR'

export const NEWLINE = 'NEWLINE'
export const EOF = 'EOF'

export const lex = (input) => {
  const source = input + '\n'
  let start = 0
  let current = 0

  let tokens = []
  const addToken = (type) => { tokens.push({ type: type }) }
  const addString = (body) => { tokens.push({ type: STRING, body }) }
  const addNumber = (numerator, denominator) => { tokens.push({ type: NUMBER, numerator, denominator }) }
  const addIdentifier = (name) => { tokens.push({ type: IDENTIFIER, value: name }) }

  const isAtEnd = () => ( current >= source.length )

  const peekAndConsume = (expected) => {
    const actual = source.slice(current, current + expected.length)

    if (actual === expected) {
      current += expected.length
      return true
    } else {
      return false
    }
  }

  const peekMatch = (regex, length = 1) => {
    const found = source.slice(current, current + length)
    return found.match(regex) !== null
  }

  const advanceUntil = (match) => {
    while (true) {
      if (isAtEnd()) {
        return
      } else {
        const found = peekAndConsume(match)
        if (found) { 
          return 
        } else {
          current += 1
        }
      } 
    }
  }

  const parseString = () => {
    advanceUntil('"')

    addString(source.slice(start + 1, current - 1))
  }

  const parseNumber = () => {
    while (peekMatch(/\d/)) { current += 1 }

    const integerPart = parseInt(source.slice(start, current))
    start = current

    if (peekMatch(/\.\d/, 2)) {
      start += 1
      current += 1
      while (peekMatch(/\d/)) { current += 1 }
    }

    const decimalPart = source.slice(start, current)

    if (`${decimalPart}`.length > 0) {
      const decBottom = parseInt(source.slice(start, current))
      const ratBottom = Math.pow(10, `${decimalPart}`.length)
      const ratTop = (integerPart * ratBottom) + decBottom
      return addNumber(ratTop, ratBottom)
    } else {
      return addNumber(integerPart, 1)
    }
  }

  const parseIdentifier = () => {
    while (peekMatch(/[a-zA-Z0-9_]/)) { current += 1 }

    const name = source.slice(start, current)

    addIdentifier(name)
  }

  const parseAnonArg = () => {
    current += 1
    while (peekMatch(/\d/)) { current += 1 }

    addIdentifier(source.slice(start, current))
  }

  const scanToken = () => {
    switch (true) {
      case peekAndConsume('#'): advanceUntil("\n"); break;
      case peekAndConsume('('): addToken(LEFT_PAREN); break
      case peekAndConsume(')'): addToken(RIGHT_PAREN); break
      case peekAndConsume('{'): addToken(LEFT_BRACE); break
      case peekAndConsume('}'): addToken(RIGHT_BRACE); break
      case peekAndConsume('['): addToken(LEFT_BRACKET); break
      case peekAndConsume(']'): addToken(RIGHT_BRACKET); break
      case peekAndConsume(','): addToken(COMMA); break
      case peekAndConsume(':'): addToken(COLON); break
      
      case peekAndConsume('->'): addToken(RIGHT_ARROW); break
      case peekAndConsume('<-'): addToken(LEFT_ARROW); break
      case peekAndConsume('|>'): addToken(RIGHT_PIPE); break
      case peekAndConsume('<|'): addToken(LEFT_PIPE); break
      
      case peekAndConsume('+'): addToken(PLUS); break
      case peekAndConsume('-'): addToken(MINUS); break
      case peekAndConsume('*'): addToken(TIMES); break
      case peekAndConsume('/'): addToken(SLASH); break
      case peekAndConsume('%'): addToken(PERCENT); break
      case peekAndConsume('^'): addToken(HAT); break
      case peekMatch(/\.[\D]/, 2): current += 1; addToken(DOT); break
      
      case peekAndConsume(' '): break
      case peekAndConsume("\t"): break
      case peekAndConsume("\r"): break
      
      case peekAndConsume("\n"): addToken(NEWLINE); break
      
      case peekAndConsume("format_as_float"): addToken(FORMAT_AS_FLOAT); break
      case peekAndConsume("format_as_ratio"): addToken(FORMAT_AS_RATIO); break
      case peekAndConsume("hide"): addToken(HIDE); break
      case peekAndConsume("function"): addToken(FUNCTION); break
      case peekAndConsume("imperative"): addToken(IMPERATIVE); break
      
      case peekAndConsume('"'): parseString(); break
      case peekMatch(/\d/): parseNumber(); break
      case peekMatch(/[a-zA-Z_]/): parseIdentifier(); break
      case peekMatch(/\$[\d]/, 2): parseAnonArg(); break

      default: 
        throw new FC_Error(`found something unexpected at position ${current}: ${source[current]}`)
    }
  }

  try {
    while(!isAtEnd()) {
      start = current
      scanToken()
    }
    addToken(EOF)
    return {tokens: tokens }
  } catch(e) {
    return { errorMessage: e }
  }
}
